import React, { useState } from 'react';
import './CreateMindModal.css'; // Reuse the Profile.css for styling
import { sendWithAuth } from '../utils/api';
import LoadingSpinner from './LoadingSpinner';
// import { useGlobalState } from '../context/GlobalState';

const CreateMindModal = ({ isOpen, onClose, isCreateMindLoading, setIsCreateMindLoading }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  // const [isLoading, setIsLoading] = useState(false);
  

  const handleCreateMind = (e) => {
    e.preventDefault();

    // Enhanced validation check
    if (!name.trim()) {
      alert('Name is required!');
      return;
    }

    if (name.includes(' ')) {
      alert('Mind name cannot contain spaces');
      return;
    }

    setIsCreateMindLoading(true);

    const tempName = name;
    const tempDescription = description;
    const payload = {
      userId: localStorage.getItem('user'), // Assuming user ID is stored in localStorage
      name: tempName,
      description: tempDescription,
    };

    setName('');
    setDescription('');
    sendWithAuth('createMind', payload, (response) => {
      // setIsCreateMindLoading(false);
      if (response.error) {
        alert(response.error.message);
      } else {
        alert('Mind creation request sent!');
        // The response will be handled by the socket listener in Main.js
      }
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal show">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Create Mind Clone</h2>
          <button className="close-modal" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          {isCreateMindLoading ? (
            <LoadingSpinner />
          ) : (
            <form onSubmit={handleCreateMind} className="form-container">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  placeholder="Name your mind clone"
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <input
                  id="description"
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                />
              </div>
              <div className="button-group">
                <button type="submit">Create</button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateMindModal; 